(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .controller('IntrumentoRelacionadoDialogController', IntrumentoRelacionadoDialogController);

    IntrumentoRelacionadoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'entity', 'IntrumentoRelacionado', 'Norma'];

    function IntrumentoRelacionadoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, entity, IntrumentoRelacionado, Norma) {
        var vm = this;

        vm.intrumentoRelacionado = entity;
        vm.clear = clear;
        vm.save = save;
        vm.normarelacionadas = Norma.query({filter: 'relacionado-is-null'});
        $q.all([vm.intrumentoRelacionado.$promise, vm.normarelacionadas.$promise]).then(function() {
            if (!vm.intrumentoRelacionado.normaRelacionadaId) {
                return $q.reject();
            }
            return Norma.get({id : vm.intrumentoRelacionado.normaRelacionadaId}).$promise;
        }).then(function(normaRelacionada) {
            vm.normarelacionadas.push(normaRelacionada);
        });
        vm.normas = Norma.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.intrumentoRelacionado.id !== null) {
                IntrumentoRelacionado.update(vm.intrumentoRelacionado, onSaveSuccess, onSaveError);
            } else {
                IntrumentoRelacionado.save(vm.intrumentoRelacionado, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('sgnmrApp:intrumentoRelacionadoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
